/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddCommentRequest } from '../model';
// @ts-ignore
import { AddRefundPreApplyStep } from '../model';
// @ts-ignore
import { AdminCancelAfterReserveRequest } from '../model';
// @ts-ignore
import { AdminDeleteCommentRequest } from '../model';
// @ts-ignore
import { AdminManualReserveFinalizationRequest } from '../model';
// @ts-ignore
import { AdminRefundHandler } from '../model';
// @ts-ignore
import { AdminRefundRequest } from '../model';
// @ts-ignore
import { AdminSetBuyAccount } from '../model';
// @ts-ignore
import { BadRequestObjectResult } from '../model';
// @ts-ignore
import { BankAccountInfoResult } from '../model';
// @ts-ignore
import { CancelAfterReserveRequest } from '../model';
// @ts-ignore
import { CreateUserFailoverTransferRequest } from '../model';
// @ts-ignore
import { CreateUserFailoverTransferResponse } from '../model';
// @ts-ignore
import { FailedPurchaseCauseResponse } from '../model';
// @ts-ignore
import { PaymentRefundStatus } from '../model';
// @ts-ignore
import { PenaltyInquiryResponse } from '../model';
// @ts-ignore
import { PreApplyRefundRequest } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { RefundDetailsResponse } from '../model';
// @ts-ignore
import { ReserveCommentsResponse } from '../model';
// @ts-ignore
import { StartManualReserveResponse } from '../model';
// @ts-ignore
import { SuperPNRCancelResponse } from '../model';
// @ts-ignore
import { SuperPNRPenaltyRequest } from '../model';
// @ts-ignore
import { SuperPNRType } from '../model';
// @ts-ignore
import { SuperpnrRequest } from '../model';
/**
 * SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {AdminManualReserveFinalizationRequest} [adminManualReserveFinalizationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostAxiosParamCreator (superPnrId: number, adminManualReserveFinalizationRequest?: AdminManualReserveFinalizationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('adminSuperPNRsSuperPnrIdFinancialEditPost', 'superPnrId', superPnrId)
    const localVarPath = `/Admin/SuperPNRs/{superPnrId}/FinancialEdit`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminManualReserveFinalizationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGet - axios parameter creator
 * 
 * @summary Get Supplier Ticket for charter flights
 * @param {number} superPnrID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetAxiosParamCreator (superPnrID: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrID' is not null or undefined
    assertParamExists('apiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGet', 'superPnrID', superPnrID)
    const localVarPath = `/api/Admin/SuperPNRs/CharterSupplierTicket/{superPnrID}`
        .replace(`{${"superPnrID"}}`, encodeURIComponent(String(superPnrID)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDelete - axios parameter creator
 * 
 * @summary delete a comment from super pnr
 * @param {number} commentId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteAxiosParamCreator (commentId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'commentId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsCommentsCommentIdDelete', 'commentId', commentId)
    const localVarPath = `/api/Admin/SuperPNRs/Comments/{CommentId}`
        .replace(`{${"CommentId"}}`, encodeURIComponent(String(commentId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCommentsHidePost - axios parameter creator
 * Sample request:                    POST /api/Admin/SuperPNRs/Comments/Hide      {        \"CommentId\" : 1,        \"Hidden\" : true      }
 * @summary Hide a comment from super pnr
 * @param {AdminDeleteCommentRequest} [adminDeleteCommentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCommentsHidePostAxiosParamCreator (adminDeleteCommentRequest?: AdminDeleteCommentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/Comments/Hide`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminDeleteCommentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCommentsPut - axios parameter creator
 * 
 * @param {Array<ReserveCommentsResponse>} [reserveCommentsResponse] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCommentsPutAxiosParamCreator (reserveCommentsResponse?: Array<ReserveCommentsResponse>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/Comments`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveCommentsResponse, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPost - axios parameter creator
 * 
 * @summary add reserve comment by attachment in admin panel
 * @param {string} [billItemId] 
 * @param {string} [text] 
 * @param {File} [file] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostAxiosParamCreator (billItemId?: string, text?: string, file?: File, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/CommentsWithAttachment`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)


    if (billItemId !== undefined) { 
        localVarFormParams.append('BillItemId', billItemId as any);
    }

    if (text !== undefined) { 
        localVarFormParams.append('Text', text as any);
    }

    if (file !== undefined) { 
        localVarFormParams.append('File', file as any);
    }


    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPost - axios parameter creator
 * 
 * @summary Complete reserve - دکمه تکمیل خودکار
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsCompleteReserveSuperPnrIdPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/CompleteReserve/{superPnrId}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsFailedPurchaseCausesGet - axios parameter creator
 * 
 * @summary Get All Failed Purchase Causes for cancellation
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsFailedPurchaseCausesGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/FailedPurchaseCauses`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {boolean} [isEdit] 
 * @param {AdminManualReserveFinalizationRequest} [adminManualReserveFinalizationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostAxiosParamCreator (superPnrId: number, isEdit?: boolean, adminManualReserveFinalizationRequest?: AdminManualReserveFinalizationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsFinalizeManualReservePost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/FinalizeManualReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (superPnrId !== undefined) {
        localVarQueryParameter['superPnrId'] = superPnrId;
    }

    if (isEdit !== undefined) {
        localVarQueryParameter['isEdit'] = isEdit;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminManualReserveFinalizationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGet - axios parameter creator
 * 
 * @param {number} paymentId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetAxiosParamCreator (paymentId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'paymentId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsPaymentRefundsPaymentIdStatusGet', 'paymentId', paymentId)
    const localVarPath = `/api/Admin/SuperPNRs/PaymentRefunds/{paymentId}/Status`
        .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsStartManualReservePost - axios parameter creator
 * 
 * @param {number} [reserveId] 
 * @param {SuperPNRType} [type] 
 * @param {boolean} [ignoreError] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsStartManualReservePostAxiosParamCreator (reserveId?: number, type?: SuperPNRType, ignoreError?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/StartManualReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveId !== undefined) {
        localVarQueryParameter['reserveId'] = reserveId;
    }

    if (type !== undefined) {
        localVarQueryParameter['type'] = type;
    }

    if (ignoreError !== undefined) {
        localVarQueryParameter['ignoreError'] = ignoreError;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGet - axios parameter creator
 * 
 * @param {number} superPNRId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetAxiosParamCreator (superPNRId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdCommentsGet', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}/Comments`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPost - axios parameter creator
 * 
 * @param {number} superPNRId 
 * @param {AddCommentRequest} [addCommentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostAxiosParamCreator (superPNRId: number, addCommentRequest?: AddCommentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdCommentsPost', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}/Comments`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost - axios parameter creator
 * 
 * @summary add reserve comment by attachment in admin panel
 * @param {number} superPNRId 
 * @param {string} [billItemId] 
 * @param {string} [text] 
 * @param {File} [file] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostAxiosParamCreator (superPNRId: number, billItemId?: string, text?: string, file?: File, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}/CommentsWithAttachment`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)


    if (billItemId !== undefined) { 
        localVarFormParams.append('BillItemId', billItemId as any);
    }

    if (text !== undefined) { 
        localVarFormParams.append('Text', text as any);
    }

    if (file !== undefined) { 
        localVarFormParams.append('File', file as any);
    }


    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDelete - axios parameter creator
 * 
 * @summary Cancel by admin
 * @param {number} superPNRId 
 * @param {AdminCancelAfterReserveRequest} [adminCancelAfterReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteAxiosParamCreator (superPNRId: number, adminCancelAfterReserveRequest?: AdminCancelAfterReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdDelete', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminCancelAfterReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPost - axios parameter creator
 * 
 * @param {number} superPNRId 
 * @param {SuperPNRPenaltyRequest} [superPNRPenaltyRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostAxiosParamCreator (superPNRId: number, superPNRPenaltyRequest?: SuperPNRPenaltyRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdPenaltyPost', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}/Penalty`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(superPNRPenaltyRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGet - axios parameter creator
 * 
 * @param {number} superPNRId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetAxiosParamCreator (superPNRId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPNRIdRefundHandlersGet', 'superPNRId', superPNRId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPNRId}/RefundHandlers`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost - axios parameter creator
 * 
 * @summary Select bank account card
 * @param {number} superPnrId 
 * @param {number} cardId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostAxiosParamCreator (superPnrId: number, cardId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost', 'superPnrId', superPnrId)
    // verify required parameter 'cardId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost', 'cardId', cardId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/AccountCardSelection/{cardId}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatch - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {AdminSetBuyAccount} [adminSetBuyAccount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchAxiosParamCreator (superPnrId: number, adminSetBuyAccount?: AdminSetBuyAccount, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdAccountPatch', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Account`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminSetBuyAccount, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPost - axios parameter creator
 * 
 * @summary Check reserve status
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdCheckStatusPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/CheckStatus`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPost - axios parameter creator
 * 
 * @summary Add refund to superPnr
 * @param {number} superPnrId 
 * @param {AdminRefundRequest} [adminRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostAxiosParamCreator (superPnrId: number, adminRefundRequest?: AdminRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost - axios parameter creator
 * 
 * @summary Refund handlers with a pre apply step should begin with this endpoint - see requires pre step in refund handlers list endpoint
 * @param {number} superPnrId 
 * @param {AdminRefundRequest} [adminRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostAxiosParamCreator (superPnrId: number, adminRefundRequest?: AdminRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/PreApply`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(adminRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostAxiosParamCreator (superPnrId: number, refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost', 'refundId', refundId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/{refundId}/Accelerate`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostAxiosParamCreator (superPnrId: number, refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost', 'refundId', refundId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/{refundId}/ConvertToPayment`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteAxiosParamCreator (superPnrId: number, refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete', 'refundId', refundId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/{refundId}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostAxiosParamCreator (superPnrId: number, refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost', 'refundId', refundId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/{refundId}/Retry`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetAxiosParamCreator (superPnrId: number, refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet', 'refundId', refundId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/Refunds/{refundId}/Status`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRegenerateTicketPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/RegenerateTicket`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPost - axios parameter creator
 * 
 * @summary request for calling from customer
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsSuperPnrIdRequestCallPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/{superPnrId}/RequestCall`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPost - axios parameter creator
 * 
 * @summary لغو کنسلی
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiAdminSuperPNRsUndoCancellationSuperPnrIdPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Admin/SuperPNRs/UndoCancellation/{superPnrId}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiAdminSuperPNRsUndoManualReservePost - axios parameter creator
 * 
 * @param {number} [reserveId] 
 * @param {SuperPNRType} [type] 
 * @param {boolean} [ignoreError] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostAxiosParamCreator (reserveId?: number, type?: SuperPNRType, ignoreError?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/SuperPNRs/UndoManualReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveId !== undefined) {
        localVarQueryParameter['reserveId'] = reserveId;
    }

    if (type !== undefined) {
        localVarQueryParameter['type'] = type;
    }

    if (ignoreError !== undefined) {
        localVarQueryParameter['ignoreError'] = ignoreError;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsPost - axios parameter creator
 * 
 * @param {SuperpnrRequest} [superpnrRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsPostAxiosParamCreator (superpnrRequest?: SuperpnrRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SuperPNRs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(superpnrRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiSuperPNRsSendCancellationTokenToBillMobileBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/SuperPNRs/SendCancellationTokenToBillMobile/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPNRIdDelete - axios parameter creator
 * 
 * @summary Cancel by user
 * @param {number} superPNRId 
 * @param {CancelAfterReserveRequest} [cancelAfterReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteAxiosParamCreator (superPNRId: number, cancelAfterReserveRequest?: CancelAfterReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPNRIdDelete', 'superPNRId', superPNRId)
    const localVarPath = `/api/SuperPNRs/{superPNRId}`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancelAfterReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPost - axios parameter creator
 * 
 * @summary get penalty and refund handlers for a superPnr by id.
 * @param {number} superPNRId 
 * @param {SuperPNRPenaltyRequest} [superPNRPenaltyRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostAxiosParamCreator (superPNRId: number, superPNRPenaltyRequest?: SuperPNRPenaltyRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPNRId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPNRIdPenaltyPost', 'superPNRId', superPNRId)
    const localVarPath = `/api/SuperPNRs/{superPNRId}/Penalty`
        .replace(`{${"superPNRId"}}`, encodeURIComponent(String(superPNRId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(superPNRPenaltyRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPost - axios parameter creator
 * 
 * @summary Refund handlers with a pre apply step should begin with this endpoint - see requires pre step in refund handlers list endpoint
 * @param {number} superPnrId 
 * @param {PreApplyRefundRequest} [preApplyRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostAxiosParamCreator (superPnrId: number, preApplyRefundRequest?: PreApplyRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdPreApplyRefundPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/PreApplyRefund`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(preApplyRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {string} [mac] 
 * @param {CreateUserFailoverTransferRequest} [createUserFailoverTransferRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostAxiosParamCreator (superPnrId: number, refundId: number, mac?: string, createUserFailoverTransferRequest?: CreateUserFailoverTransferRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost', 'refundId', refundId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/Refunds/{refundId}/CreateUserFailoverTransfer`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createUserFailoverTransferRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetAxiosParamCreator (superPnrId: number, refundId: number, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet', 'refundId', refundId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/Refunds/{refundId}/Details`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet - axios parameter creator
 * 
 * @summary Returns IBAN account information when its owner matches the original refund destination owner.
 * @param {number} superPnrId 
 * @param {number} refundId 
 * @param {string} [mac] 
 * @param {string} [iban] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetAxiosParamCreator (superPnrId: number, refundId: number, mac?: string, iban?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet', 'superPnrId', superPnrId)
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet', 'refundId', refundId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/Refunds/{refundId}/InquiryUserFailoverAccount`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }

    if (iban !== undefined) {
        localVarQueryParameter['iban'] = iban;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {string} [mac] 
 * @param {string} [iban] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostAxiosParamCreator (superPnrId: number, mac?: string, iban?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdUploadIbanPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/uploadIban`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }

    if (iban !== undefined) {
        localVarQueryParameter['iban'] = iban;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperPnrIdUploadIbanRequestPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/SuperPNRs/{superPnrId}/uploadIbanRequest`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePost - axios parameter creator
 * 
 * @param {number} superpnrId 
 * @param {Array<File>} [files] 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostAxiosParamCreator (superpnrId: number, files?: Array<File>, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superpnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperpnrIdUploadFilePost', 'superpnrId', superpnrId)
    const localVarPath = `/api/SuperPNRs/{superpnrId}/uploadFile`
        .replace(`{${"superpnrId"}}`, encodeURIComponent(String(superpnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (files) {
        files.forEach((element) => {
            localVarFormParams.append('Files', element as any);
        })
    }


    if (mac !== undefined) { 
        localVarFormParams.append('Mac', mac as any);
    }


    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPost - axios parameter creator
 * 
 * @param {number} superpnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostAxiosParamCreator (superpnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superpnrId' is not null or undefined
    assertParamExists('apiSuperPNRsSuperpnrIdUploadFileRequestPost', 'superpnrId', superpnrId)
    const localVarPath = `/api/SuperPNRs/{superpnrId}/uploadFileRequest`
        .replace(`{${"superpnrId"}}`, encodeURIComponent(String(superpnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet - axios parameter creator
 * 
 * @summary get url of ticket and preview ticket
 * @param {number} superPnrId 
 * @param {string} mac 
 * @param {boolean} [preview] 
 * @param {string} [lang] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetAxiosParamCreator (superPnrId: number, mac: string, preview?: boolean, lang?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsTicketSuperPnrIdMacGet', 'superPnrId', superPnrId)
    // verify required parameter 'mac' is not null or undefined
    assertParamExists('apiSuperPNRsTicketSuperPnrIdMacGet', 'mac', mac)
    const localVarPath = `/api/SuperPNRs/Ticket/{superPnrId}/{mac}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"mac"}}`, encodeURIComponent(String(mac)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (preview !== undefined) {
        localVarQueryParameter['preview'] = preview;
    }

    if (lang !== undefined) {
        localVarQueryParameter['lang'] = lang;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGet - axios parameter creator
 * 
 * @summary get train tickets which finalize manually
 * @param {number} superPnrId 
 * @param {string} mac 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetAxiosParamCreator (superPnrId: number, mac: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiSuperPNRsTrainTicketSuperPnrIdMacGet', 'superPnrId', superPnrId)
    // verify required parameter 'mac' is not null or undefined
    assertParamExists('apiSuperPNRsTrainTicketSuperPnrIdMacGet', 'mac', mac)
    const localVarPath = `/api/SuperPNRs/TrainTicket/{superPnrId}/{mac}`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)))
        .replace(`{${"mac"}}`, encodeURIComponent(String(mac)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for adminSuperPNRsSuperPnrIdFinancialEditPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostRequest
 */
export interface SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {AdminManualReserveFinalizationRequest}
     * @memberof SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPost
     */
    readonly adminManualReserveFinalizationRequest?: AdminManualReserveFinalizationRequest
}

/**
 * Request parameters for apiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGet
     */
    readonly superPnrID: number
}

/**
 * Request parameters for apiAdminSuperPNRsCommentsCommentIdDelete operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDelete
     */
    readonly commentId: number
}

/**
 * Request parameters for apiAdminSuperPNRsCommentsHidePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCommentsHidePostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCommentsHidePostRequest {
    /**
     * 
     * @type {AdminDeleteCommentRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsHidePost
     */
    readonly adminDeleteCommentRequest?: AdminDeleteCommentRequest
}

/**
 * Request parameters for apiAdminSuperPNRsCommentsPut operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCommentsPutRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCommentsPutRequest {
    /**
     * 
     * @type {Array<ReserveCommentsResponse>}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsPut
     */
    readonly reserveCommentsResponse?: Array<ReserveCommentsResponse>
}

/**
 * Request parameters for apiAdminSuperPNRsCommentsWithAttachmentPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPost
     */
    readonly billItemId?: string

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPost
     */
    readonly text?: string

    /**
     * 
     * @type {File}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPost
     */
    readonly file?: File
}

/**
 * Request parameters for apiAdminSuperPNRsCompleteReserveSuperPnrIdPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiAdminSuperPNRsFinalizeManualReservePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {boolean}
     * @memberof SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePost
     */
    readonly isEdit?: boolean

    /**
     * 
     * @type {AdminManualReserveFinalizationRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePost
     */
    readonly adminManualReserveFinalizationRequest?: AdminManualReserveFinalizationRequest
}

/**
 * Request parameters for apiAdminSuperPNRsPaymentRefundsPaymentIdStatusGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGet
     */
    readonly paymentId: number
}

/**
 * Request parameters for apiAdminSuperPNRsStartManualReservePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsStartManualReservePostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsStartManualReservePostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsStartManualReservePost
     */
    readonly reserveId?: number

    /**
     * 
     * @type {SuperPNRType}
     * @memberof SuperPNRsApiApiAdminSuperPNRsStartManualReservePost
     */
    readonly type?: SuperPNRType

    /**
     * 
     * @type {boolean}
     * @memberof SuperPNRsApiApiAdminSuperPNRsStartManualReservePost
     */
    readonly ignoreError?: boolean
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdCommentsGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGet
     */
    readonly superPNRId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdCommentsPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPost
     */
    readonly superPNRId: number

    /**
     * 
     * @type {AddCommentRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPost
     */
    readonly addCommentRequest?: AddCommentRequest
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost
     */
    readonly superPNRId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost
     */
    readonly billItemId?: string

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost
     */
    readonly text?: string

    /**
     * 
     * @type {File}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost
     */
    readonly file?: File
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdDelete operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDelete
     */
    readonly superPNRId: number

    /**
     * 
     * @type {AdminCancelAfterReserveRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDelete
     */
    readonly adminCancelAfterReserveRequest?: AdminCancelAfterReserveRequest
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdPenaltyPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPost
     */
    readonly superPNRId: number

    /**
     * 
     * @type {SuperPNRPenaltyRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPost
     */
    readonly superPNRPenaltyRequest?: SuperPNRPenaltyRequest
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPNRIdRefundHandlersGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGet
     */
    readonly superPNRId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost
     */
    readonly cardId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdAccountPatch operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatch
     */
    readonly superPnrId: number

    /**
     * 
     * @type {AdminSetBuyAccount}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatch
     */
    readonly adminSetBuyAccount?: AdminSetBuyAccount
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdCheckStatusPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {AdminRefundRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPost
     */
    readonly adminRefundRequest?: AdminRefundRequest
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {AdminRefundRequest}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost
     */
    readonly adminRefundRequest?: AdminRefundRequest
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost
     */
    readonly refundId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost
     */
    readonly refundId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete
     */
    readonly refundId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost
     */
    readonly refundId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet
     */
    readonly refundId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRegenerateTicketPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiAdminSuperPNRsSuperPnrIdRequestCallPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiAdminSuperPNRsUndoCancellationSuperPnrIdPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiAdminSuperPNRsUndoManualReservePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostRequest
 */
export interface SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiAdminSuperPNRsUndoManualReservePost
     */
    readonly reserveId?: number

    /**
     * 
     * @type {SuperPNRType}
     * @memberof SuperPNRsApiApiAdminSuperPNRsUndoManualReservePost
     */
    readonly type?: SuperPNRType

    /**
     * 
     * @type {boolean}
     * @memberof SuperPNRsApiApiAdminSuperPNRsUndoManualReservePost
     */
    readonly ignoreError?: boolean
}

/**
 * Request parameters for apiSuperPNRsPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsPostRequest {
    /**
     * 
     * @type {SuperpnrRequest}
     * @memberof SuperPNRsApiApiSuperPNRsPost
     */
    readonly superpnrRequest?: SuperpnrRequest
}

/**
 * Request parameters for apiSuperPNRsSendCancellationTokenToBillMobileBillCodePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePost
     */
    readonly billCode: string
}

/**
 * Request parameters for apiSuperPNRsSuperPNRIdDelete operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPNRIdDelete
     */
    readonly superPNRId: number

    /**
     * 
     * @type {CancelAfterReserveRequest}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPNRIdDelete
     */
    readonly cancelAfterReserveRequest?: CancelAfterReserveRequest
}

/**
 * Request parameters for apiSuperPNRsSuperPNRIdPenaltyPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPost
     */
    readonly superPNRId: number

    /**
     * 
     * @type {SuperPNRPenaltyRequest}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPost
     */
    readonly superPNRPenaltyRequest?: SuperPNRPenaltyRequest
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdPreApplyRefundPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {PreApplyRefundRequest}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPost
     */
    readonly preApplyRefundRequest?: PreApplyRefundRequest
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost
     */
    readonly refundId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost
     */
    readonly mac?: string

    /**
     * 
     * @type {CreateUserFailoverTransferRequest}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost
     */
    readonly createUserFailoverTransferRequest?: CreateUserFailoverTransferRequest
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet
     */
    readonly refundId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet
     */
    readonly mac?: string
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet
     */
    readonly refundId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet
     */
    readonly mac?: string

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet
     */
    readonly iban?: string
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdUploadIbanPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPost
     */
    readonly mac?: string

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPost
     */
    readonly iban?: string
}

/**
 * Request parameters for apiSuperPNRsSuperPnrIdUploadIbanRequestPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPost
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiSuperPNRsSuperpnrIdUploadFilePost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePost
     */
    readonly superpnrId: number

    /**
     * 
     * @type {Array<File>}
     * @memberof SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePost
     */
    readonly files?: Array<File>

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePost
     */
    readonly mac?: string
}

/**
 * Request parameters for apiSuperPNRsSuperpnrIdUploadFileRequestPost operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostRequest
 */
export interface SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPost
     */
    readonly superpnrId: number
}

/**
 * Request parameters for apiSuperPNRsTicketSuperPnrIdMacGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetRequest
 */
export interface SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet
     */
    readonly mac: string

    /**
     * 
     * @type {boolean}
     * @memberof SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet
     */
    readonly preview?: boolean

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet
     */
    readonly lang?: string
}

/**
 * Request parameters for apiSuperPNRsTrainTicketSuperPnrIdMacGet operation in SuperPNRsApi.
 * @export
 * @interface SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetRequest
 */
export interface SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {string}
     * @memberof SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGet
     */
    readonly mac: string
}

/**
* 
* @param {SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPost(requestParameters: SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiAdminSuperPNRsSuperPnrIdFinancialEditPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.adminManualReserveFinalizationRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Supplier Ticket for charter flights
* @param {SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGet(requestParameters: SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCharterSupplierTicketSuperPnrIDGetAxiosParamCreator(requestParameters.superPnrID, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary delete a comment from super pnr
* @param {SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDelete(requestParameters: SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCommentsCommentIdDeleteAxiosParamCreator(requestParameters.commentId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Sample request:                    POST /api/Admin/SuperPNRs/Comments/Hide      {        \"CommentId\" : 1,        \"Hidden\" : true      }
* @summary Hide a comment from super pnr
* @param {SuperPNRsApiApiAdminSuperPNRsCommentsHidePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCommentsHidePost(requestParameters: SuperPNRsApiApiAdminSuperPNRsCommentsHidePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCommentsHidePostAxiosParamCreator(requestParameters.adminDeleteCommentRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsCommentsPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCommentsPut(requestParameters: SuperPNRsApiApiAdminSuperPNRsCommentsPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCommentsPutAxiosParamCreator(requestParameters.reserveCommentsResponse, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary add reserve comment by attachment in admin panel
* @param {SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCommentsWithAttachmentPostAxiosParamCreator(requestParameters.billItemId, requestParameters.text, requestParameters.file, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Complete reserve - دکمه تکمیل خودکار
* @param {SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsCompleteReserveSuperPnrIdPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get All Failed Purchase Causes for cancellation
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsFailedPurchaseCausesGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsFailedPurchaseCausesGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<FailedPurchaseCauseResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePost(requestParameters: SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsFinalizeManualReservePostAxiosParamCreator(requestParameters.superPnrId, requestParameters.isEdit, requestParameters.adminManualReserveFinalizationRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGet(requestParameters: SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsPaymentRefundsPaymentIdStatusGetAxiosParamCreator(requestParameters.paymentId, options, configuration);
    const request: () => AxiosPromise<PaymentRefundStatus> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsStartManualReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsStartManualReservePost(requestParameters: SuperPNRsApiApiAdminSuperPNRsStartManualReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsStartManualReservePostAxiosParamCreator(requestParameters.reserveId, requestParameters.type, requestParameters.ignoreError, options, configuration);
    const request: () => AxiosPromise<StartManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGet(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsGetAxiosParamCreator(requestParameters.superPNRId, options, configuration);
    const request: () => AxiosPromise<Array<ReserveCommentsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsPostAxiosParamCreator(requestParameters.superPNRId, requestParameters.addCommentRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary add reserve comment by attachment in admin panel
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdCommentsWithAttachmentPostAxiosParamCreator(requestParameters.superPNRId, requestParameters.billItemId, requestParameters.text, requestParameters.file, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Cancel by admin
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDelete(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdDeleteAxiosParamCreator(requestParameters.superPNRId, requestParameters.adminCancelAfterReserveRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdPenaltyPostAxiosParamCreator(requestParameters.superPNRId, requestParameters.superPNRPenaltyRequest, options, configuration);
    const request: () => AxiosPromise<PenaltyInquiryResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGet(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPNRIdRefundHandlersGetAxiosParamCreator(requestParameters.superPNRId, options, configuration);
    const request: () => AxiosPromise<Array<AdminRefundHandler>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Select bank account card
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountCardSelectionCardIdPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.cardId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatch(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdAccountPatchAxiosParamCreator(requestParameters.superPnrId, requestParameters.adminSetBuyAccount, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Check reserve status
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdCheckStatusPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Add refund to superPnr
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.adminRefundRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Refund handlers with a pre apply step should begin with this endpoint - see requires pre step in refund handlers list endpoint
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsPreApplyPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.adminRefundRequest, options, configuration);
    const request: () => AxiosPromise<AddRefundPreApplyStep> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdAcceleratePostAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdConvertToPaymentPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDelete(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdDeleteAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdRetryPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGet(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRefundsRefundIdStatusGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<PaymentRefundStatus> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRegenerateTicketPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary request for calling from customer
* @param {SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsSuperPnrIdRequestCallPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary لغو کنسلی
* @param {SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPost(requestParameters: SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsUndoCancellationSuperPnrIdPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiAdminSuperPNRsUndoManualReservePost(requestParameters: SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiAdminSuperPNRsUndoManualReservePostAxiosParamCreator(requestParameters.reserveId, requestParameters.type, requestParameters.ignoreError, options, configuration);
    const request: () => AxiosPromise<StartManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsPost(requestParameters: SuperPNRsApiApiSuperPNRsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsPostAxiosParamCreator(requestParameters.superpnrRequest, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePost(requestParameters: SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSendCancellationTokenToBillMobileBillCodePostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Cancel by user
* @param {SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPNRIdDelete(requestParameters: SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPNRIdDeleteAxiosParamCreator(requestParameters.superPNRId, requestParameters.cancelAfterReserveRequest, options, configuration);
    const request: () => AxiosPromise<SuperPNRCancelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get penalty and refund handlers for a superPnr by id.
* @param {SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPNRIdPenaltyPostAxiosParamCreator(requestParameters.superPNRId, requestParameters.superPNRPenaltyRequest, options, configuration);
    const request: () => AxiosPromise<PenaltyInquiryResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Refund handlers with a pre apply step should begin with this endpoint - see requires pre step in refund handlers list endpoint
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdPreApplyRefundPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.preApplyRefundRequest, options, configuration);
    const request: () => AxiosPromise<AddRefundPreApplyStep> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdCreateUserFailoverTransferPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, requestParameters.mac, requestParameters.createUserFailoverTransferRequest, options, configuration);
    const request: () => AxiosPromise<CreateUserFailoverTransferResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGet(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdDetailsGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<RefundDetailsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Returns IBAN account information when its owner matches the original refund destination owner.
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGet(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdRefundsRefundIdInquiryUserFailoverAccountGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.refundId, requestParameters.mac, requestParameters.iban, options, configuration);
    const request: () => AxiosPromise<BankAccountInfoResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.mac, requestParameters.iban, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperPnrIdUploadIbanRequestPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePost(requestParameters: SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFilePostAxiosParamCreator(requestParameters.superpnrId, requestParameters.files, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPost(requestParameters: SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsSuperpnrIdUploadFileRequestPostAxiosParamCreator(requestParameters.superpnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get url of ticket and preview ticket
* @param {SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGet(requestParameters: SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsTicketSuperPnrIdMacGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.mac, requestParameters.preview, requestParameters.lang, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get train tickets which finalize manually
* @param {SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGet(requestParameters: SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SuperPNRsApiApiSuperPNRsTrainTicketSuperPnrIdMacGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
